// extracted by mini-css-extract-plugin
export default {"asSeenOn":"P_dg","templateTwo":"P_cX"};